import React from "react";
import { Navigate, Route, Routes, BrowserRouter as Router } from "react-router-dom";
import ScrollToTop from "./common/ScrollToTop";

import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux';
import { persistor, store } from "./store/store";
import { NotFound } from "./views/NotFound";

import ROIPage from "./views/pages/roi-calculator/ROIPage";

import ROIPageCondition from "./views/pages/roi-calculator/ROIPageCondition.js";

import ROIReportSingle from "./views/pages/roi-calculator/ROIReportSingle";
import ROIReport from "./views/pages/roi-calculator/ROIReport";
import ROIForm from "./views/pages/roi-calculator/ROIForm";
import CustomComponents from "./views/pages/roi-calculator/CustomComponents";

import ROIReportSubmitted from "./views/pages/roi-calculator/ROIReportSubmitted.js";

import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ScrollToTop>
          <Routes>
            <Route exact path="/not-found/" element={< NotFound />}> </Route>
            <Route exact path="/" element={<Navigate to={'not-found'}> </Navigate>}> </Route>
            <Route exact path="*" element={<Navigate to={'not-found'}> </Navigate>}> </Route>

            {/* Start ROI Route */}
            <Route exact path="/roi/condition" element={<ROIPageCondition />} />
            <Route exact path="/roi/:roiId" element={<ROIPage />} />
            <Route exact path="/roi/form/:roiId" element={<ROIForm />} />
            <Route exact path="/roi/report" element={<ROIReport />} />
            <Route exact path="/roi/report-single" element={<ROIReportSingle />} />
            <Route exact path="/roi/custom-component" element={<CustomComponents />} />
            <Route exact path="/roi/:roiId/report/:submittedID" element={<ROIReportSubmitted />} />

          </Routes>

        </ScrollToTop>
      </PersistGate>
    </Provider >
  );
}

export default App;
